// create container for toasts
const ul = document.createElement('ul');
ul.classList.add('ps-toast-list');
document.body.append(ul);

class ToastProvider
{
	static async show(toast_definition, bindings, display_options)
	{
		let instance; // Toast class instance
		const {element, toast } = toast_definition;
		const toast_element = window.document.createElement('li');
		toast_element.classList.add('ps-toast');

		// move all child elements added by grape.toast inside of toast element
		// TODO maybe grape.toast should allow providers to do more of the work?
		while(element.firstChild) toast_element.appendChild(element.firstChild);

		ul.appendChild(toast_element);

		try {
			if (toast.toast_class)
			{
				try {
					instance = new toast.toast_class(bindings, toast_element);
				} catch (e) {
					console.error(e);
				}
			}

			if (toast.pageClass)
			{
				try {
					instance = new toast.pageClass(bindings, toast_element);
				} catch (e) {

					console.error(e);
				}
			}
		} catch (e) {
			console.error('Error on toast_class instantiation');
			console.error(e);
			instance = new Object();
		}

		if (instance.hasOwnProperty('viewModel'))
		{
			try {
				window.ko.applyBindings(instance.viewModel, toast_element);
			} catch (e) {
				console.error('Error while applying bindings vm:', instance.viewModel, 'target:', toast_element);
				console.error(e);
			}
		}

		if (instance?.init && typeof instance.init === 'function')
		{
			try {
				instance.init();
			} catch (e) {
				console.error('Error while running toast init');
				console.error(e);
			}
		}

		if (instance?.updateData && typeof instance.updateData === 'function')
		{
			try {
				instance.updateData();
			} catch (e) {
				console.error('Error while running toast updateData');
				console.error(e);
			}
		}

		let close_event_func = (event) => {
			instance.close();
		};

		instance.close = async (data) => {
			if (instance.status === 'closing')
				return;
			toast_element.removeEventListener("close", close_event_func);
			toast_element.classList.add('ps-toast-hide');
			instance.status = 'closing';
			if (instance.hasOwnProperty('beforeClose') && instance.beforeClose instanceof Function)
			{
				await instance.beforeClose.call(instance, data);
			}

			setTimeout((event)=>{
				window.ko.cleanNode(toast_element);
				ul.removeChild(toast_element);
			},500);//wait for animations before removing
			// TODO find a better way of handling this?

			if (display_options.hasOwnProperty('onClose') && display_options.onClose instanceof Function)
			{
				display_options.onClose.call(instance, data);
			}
		};
	}
}

export default ToastProvider;
